import { Button, Icon, ButtonProps } from 'semantic-ui-react';
import { FormContextType, RJSFSchema, StrictRJSFSchema, TranslatableString } from '@rjsf/utils';

import { SemanticIconButtonProps } from '../IconButton';

/** The `AddButton` renders a button that represent the `Add` action on a form
 */
export default function AddButton<T = any, S extends StrictRJSFSchema = RJSFSchema, F extends FormContextType = any>({
  uiSchema,
  registry,
  color,
  ...props
}: SemanticIconButtonProps<T, S, F>) {
  const { translateString } = registry;
  return (
    <Button
      title={translateString(TranslatableString.AddItemButton)}
      color={color as ButtonProps['color']}
      size='tiny'
      {...props}
      icon
    >
      <Icon name='plus' />
    </Button>
  );
}
